module.exports = __webpack_public_path__ + "img/search.ea929215.svg";